import type { AnyObject } from '$util/types';

interface BreakpointOrders {
  tabletOrder?: number;
  desktopOrder?: number;
  widescreenOrder?: number;
}

export function makeContentComponentOrderStyles(breakpointOrders: BreakpointOrders): AnyObject | undefined {
  const entries = breakpointOrders && Object.values(breakpointOrders).filter(Boolean);

  if (entries?.length) {
    const { tabletOrder, desktopOrder, widescreenOrder } = breakpointOrders;
    const styleObject: AnyObject = {};

    if (tabletOrder) {
      styleObject['--tablet-order'] = tabletOrder;
    }
    if (desktopOrder) {
      styleObject['--desktop-order'] = desktopOrder;
    }
    if (widescreenOrder) {
      styleObject['--widescreen-order'] = widescreenOrder;
    }

    return styleObject;
  }
  return undefined;
}
